import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="post-harvest--carry-over-received"
// Manages per-container received/not-received decisions for carry-over steps
// (internal_transport, post_harvest_ingress, storage).
export default class extends Controller {
  static targets = [
    "containerList",
    "containersDataField",
    "receivedCount",
    "notReceivedCount",
    "pendingCount",
    "pendingBadge",
    "receivedBadge",
    "notReceivedBadge"
  ]

  connect() {
    this.updateUI()
    this.serialize()
  }

  setReceived({ params: { received }, currentTarget }) {
    const row = currentTarget.closest("[data-container-row]")
    const isReceived = received === true || received === "true"

    // Check the correct radio
    row.querySelectorAll(`input[data-field="received"]`).forEach((r) => {
      r.checked = r.value === String(isReceived)
    })

    // Update toggle buttons
    const toggle = row.querySelector("[data-received-toggle]")
    if (toggle) {
      toggle.querySelectorAll("button").forEach((btn) => {
        btn.className = "btn btn-sm border-0 gap-1 btn-ghost"
      })
      if (isReceived) {
        currentTarget.className =
          "btn btn-sm border-0 gap-1 btn-success text-success-content"
      } else {
        currentTarget.className =
          "btn btn-sm border-0 gap-1 btn-error text-error-content"
      }
    }

    // Update card border
    row.classList.remove("border-success/20", "border-error/20", "border-base-200")
    if (isReceived) {
      row.classList.add("border-success/20")
    } else {
      row.classList.add("border-error/20")
    }

    // Toggle note fields (shown when not received)
    const noteFields = row.querySelector("[data-note-fields]")
    if (noteFields) {
      noteFields.classList.toggle("hidden", isReceived)
    }

    this.updateUI()
    this.serialize()
  }

  update() {
    this.updateUI()
    this.serialize()
  }

  updateUI() {
    const rows = this.containerListTarget.querySelectorAll("[data-container-row]")
    let received = 0
    let notReceived = 0
    let pending = 0

    rows.forEach((row) => {
      const radio = row.querySelector("input[data-field='received']:checked")
      const value = radio?.value

      if (value === "true") {
        received++
      } else if (value === "false") {
        notReceived++
      } else {
        pending++
      }
    })

    if (this.hasReceivedCountTarget)
      this.receivedCountTarget.textContent = received
    if (this.hasNotReceivedCountTarget)
      this.notReceivedCountTarget.textContent = notReceived
    if (this.hasPendingCountTarget)
      this.pendingCountTarget.textContent = pending

    if (this.hasPendingBadgeTarget)
      this.pendingBadgeTarget.classList.toggle("hidden", pending === 0)
    if (this.hasReceivedBadgeTarget)
      this.receivedBadgeTarget.classList.toggle("hidden", received === 0)
    if (this.hasNotReceivedBadgeTarget)
      this.notReceivedBadgeTarget.classList.toggle("hidden", notReceived === 0)
  }

  serialize() {
    const rows = this.containerListTarget.querySelectorAll("[data-container-row]")
    const containers = []

    rows.forEach((row) => {
      const containerId = row.dataset.containerId
      const radio = row.querySelector("input[data-field='received']:checked")
      const receivedValue = radio?.value
      if (receivedValue === undefined || receivedValue === "") return

      const entry = {
        container_id: parseInt(containerId),
        received: receivedValue === "true"
      }

      // Always capture photo
      const signedId = row.querySelector("[data-post-harvest--photo-upload-target='signedId']")?.value || ""
      if (signedId) entry.received_photo_signed_id = signedId

      // Capture note when not received
      if (!entry.received) {
        entry.note =
          row.querySelector("[data-field='note']")?.value || ""
      }

      containers.push(entry)
    })

    this.containersDataFieldTarget.value = JSON.stringify(containers)
  }
}
